
import React from 'react';

const UlosotonToimintaSection: React.FC = () => {
  return (
    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Miten toimia, jos velka on jo ulosotossa?</h2>
      <p className="mb-6 text-gray-700">
        Jos velka on jo edennyt ulosottoon, kannattaa toimia seuraavasti:
      </p>

      <ol className="list-decimal pl-6 space-y-4 mb-8">
        <li className="text-gray-700">
          <strong className="text-gray-800">Ota yhteyttä ulosottomieheen</strong> - Keskustele tilanteestasi avoimesti ja selvitä eri maksuvaihtoehdot.
        </li>
        <li className="text-gray-700">
          <strong className="text-gray-800">Sovi maksusuunnitelmasta</strong> - Ulosottomiehen kanssa voi usein neuvotella maksusuunnitelmasta, 
          joka huomioi maksukyvyn.
        </li>
        <li className="text-gray-700">
          <strong className="text-gray-800">Hae maksuaikaa</strong> - Voit hakea lisää maksuaikaa, jos sinulla on väliaikainen maksuvaikeus.
        </li>
        <li className="text-gray-700">
          <strong className="text-gray-800">Selvitä velkajärjestelyn mahdollisuus</strong> - Vakavissa tapauksissa velkajärjestely voi olla vaihtoehto.
        </li>
      </ol>
      
      <div className="p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-800">
          <strong>Muista:</strong> Avoin yhteydenpito ulosottoviranomaisen kanssa on tärkeää. Älä jätä ulosottokirjeitä huomiotta,
          vaan ole aktiivisesti yhteydessä viranomaisiin.
        </p>
      </div>
    </section>
  );
};

export default UlosotonToimintaSection;
